module.exports = __webpack_public_path__ + "img/Feature.60620fe4.jpg";